import { image_pb } from 'libs/generated-grpc-ts';
import { ReportSortBy } from 'libs/util';

import { HallPassStudentCreatedFilter } from '../';
import { GroupType } from '../';

/** @deprecated use HpmReportsFilters */
export interface ISummaryOptions {
  startDate: string;
  endDate: string;
  groupBy: GroupType;
  issuedTo?: number[];
  issuedBy?: number[];
  passTypes?: number[];
  studentCreated: HallPassStudentCreatedFilter;
  /** @deprecated, only used in stats aggr */
  orderByTotalTime?: any;
  /** @deprecated, only used in stats aggr */
  orderByTotalPasses?: any;
  sort?: ReportSortBy;
  userList: number[];
  isKiosk?: boolean;
}

/** @deprecated use HpmReportsFilters */
export type ITopTypesOptions = Omit<ISummaryOptions, 'groupBy'> & {
  offset?: number;
  limit?: number;
};

/** @deprecated use HpmReportsFilters */
export type ITopUsersOptions = ITopTypesOptions;

/** @deprecated use HpmReportsFilters */
export type ITopCreatorsOptions = ITopTypesOptions;

/** @deprecated use HpmReportsFilters */
export type IExpiredTimeReportOptions = ITopTypesOptions;

export interface IHallPassSummaryResult {
  typeId: number;
  year?: number;
  month?: number;
  date?: string;
  hour?: number;
  week?: number;
  totalPasses?: number;
  totalTime?: number;
  typeName: string;
  typeColor: string;
  totalDenied?: number;
}

export interface IHallPassUserResult {
  typeId: number;
  month?: number;
  date?: string;
  hour?: number;
  week?: number;
  totalPasses?: number;
  totalTime?: number;
  issuedTo?: number;
  issuedBy?: number;
  totalDenied?: number;
  totalOverridden?: number;
}

export interface IHallPassExpiredResult {
  issuedTo?: number;
  noOfExpiredPasses: number;
  totalExpiredTime: number;
}

export interface IHallPassStatsPeople {
  studentId: string;
  id: number;
  grade: string;
  role: string;
  badgeIconUrl: string;
  personHash: string;
  firstName: string;
  lastName: string;
  email?: string;
}

export interface IHallPassStatsPeopleResult {
  person: IHallPassStatsPeople;
  stats: IHallPassUserResult;
}

export interface IHallPassStatsExpiredTimeResult {
  person: IHallPassStatsPeople;
  expiredStats: IHallPassExpiredResult;
}

export interface IHallPassClassTypeCount {
  count: number;
  id?: number;
  name?: string;
  asset?: image_pb.ImageInfo;
  bannerHash?: string;
  color?: string;
  active?: boolean;
  priority?: number;
  defaultHallPassTime?: number;
  requireTeacherApproval?: boolean;
  manuallyEndPass?: boolean;
}

export enum IReportType {
  SUMMARY = 'summary',
  TYPES = 'types',
  USER = 'user',
  CREATOR = 'creator',
  HISTORY = 'history',
  LATE = 'late',
}
